export default __webpack_public_path__ + "static/media/logo-sistema.63600e50.svg";